<template>
    <div class="student-progress-area">
        <div class="container-fluid">
            <div class="row justify-content-center">
                <div class="col-lg-8">
                    <div class="row justify-content-center">
                        <div class="col-xxl-6">
                            <StudentProgress />
                        </div>

                        <div class="col-xxl-6">
                            <WorksStats />
                        </div>
                    </div>

                    <div class="row justify-content-center">
                        <div class="col-xxl-8">
                            <ActivityStatisticsChart />
                        </div>

                        <div class="col-xxl-4">
                            <TotalStudentWrap />
                        </div>
                    </div>

                    <ActivityStatistics />
                </div>

                <div class="col-lg-4">
                    <UpcomingGroupLessons />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import StudentProgress from './StudentProgress'
import WorksStats from './WorksStats'
import ActivityStatisticsChart from '../HrManagement/ActivityStatisticsChart'
import TotalStudentWrap from './TotalStudentWrap'
import ActivityStatistics from './ActivityStatistics'
import UpcomingGroupLessons from './UpcomingGroupLessons'

export default {
    name: 'HrManagementContent',
    components: {
        StudentProgress,
        WorksStats,
        ActivityStatisticsChart,
        TotalStudentWrap,
        ActivityStatistics,
        UpcomingGroupLessons,
    },
}
</script>

<style lang="scss">
/* Min width 1200px to Max width 1320px */
@media only screen and (min-width: 1200px) and (max-width: 1399px) {
    .student-progress-area {
        .total-student-wrap {
            .col-lg-12 {
                flex: 0 0 auto;
                width: 50%;
            }
        }
    }
}
</style>